import { injectable } from 'inversify';

import {
  GetAccountWidgetBannerResponse,
  SlideItemConstruct,
} from '@app/gen/dashboard';

@injectable()
export class WidgetBannerMapper {
  processWidgetBanner(widgetBanner: GetAccountWidgetBannerResponse) {
    const { slides, type } = widgetBanner.banner || {};
    const maxSlidesLength = 3;
    return {
      type: type,
      slides: slides?.slice(0, maxSlidesLength).map((slide) => {
        if (type === 'simple') {
          const { url, background_image_id: background } = slide;
          return {
            url,
            background,
          };
        }
        const {
          background_image_id: background,
          additional_image_id: image,
          button_type: buttonType,
          button_text: buttonText,
          text_color: textColor,
          ...rest
        } = slide as SlideItemConstruct;

        return {
          ...rest,
          background,
          image,
          buttonVariant: buttonType || 'primary',
          buttonText: buttonText || '',
          textColor: textColor || 'black',
        };
      }),
    };
  }
}
